import { IPropertyInfoMetadata } from "../../../DotNet/SeriouslyRAD.Framework/Reflection/IPropertyInfoMetadata";
import { EntityBaseProperties, IEntityBaseProperties } from "./EntityBaseProperties";

export interface ISoftDeletableEntityProperties extends IEntityBaseProperties
{
    deletedByUserId: IPropertyInfoMetadata;
    deletedDate: IPropertyInfoMetadata;
    deletedGuid: IPropertyInfoMetadata;
    deletedWhileElevated: IPropertyInfoMetadata;

    deletedByUser: IPropertyInfoMetadata;
}

export const SoftDeletableEntityProperties: ISoftDeletableEntityProperties = {

    ...EntityBaseProperties,

    deletedByUserId: {
        attributes: [
            {
                $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                description: "Deleted By User"
            },
            {
                $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                displayName: "Deleted By User"
            }
        ],
        name: "DeletedByUserId",
        propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
        $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
    },
    deletedDate: {
        attributes: [
            {
                $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                description: "Deleted Date"
            },
            {
                $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                displayName: "Deleted Date"
            }
        ],
        name: "DeletedDate",
        propertyTypeId: "System.Nullable`1[[System.DateTime, System.Private.CoreLib]], System.Private.CoreLib",
        $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
    },
    deletedGuid: {
        attributes: [
            {
                $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                description: "Deleted Guid"
            },
            {
                $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                displayName: "Deleted Guid"
            }
        ],
        name: "DeletedGuid",
        propertyTypeId: "System.Nullable`1[[System.Guid, System.Private.CoreLib]], System.Private.CoreLib",
        $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
    },
    deletedWhileElevated: {
        attributes: [
            {
                $type: "SeriouslyRAD.Framework.ClientAwareDescriptionAttribute, SeriouslyRAD.Framework",
                description: "Deleted While Elevated"
            },
            {
                $type: "SeriouslyRAD.Framework.ClientAwareDisplayNameAttribute, SeriouslyRAD.Framework",
                displayName: "Deleted While Elevated"
            }
        ],
        name: "DeletedWhileElevated",
        propertyTypeId: "System.Nullable`1[[System.Boolean, System.Private.CoreLib]], System.Private.CoreLib",
        $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
    },

    deletedByUser: {
        attributes: [],
        name: "DeletedByUser",
        propertyTypeId: "SeriouslyRAD.Framework.Data.Entities.User, SeriouslyRAD.Framework.Data.Entities",
        $type: "SeriouslyRAD.Framework.Reflection.PropertyInfoMetadata, SeriouslyRAD.Framework"
    },

};